export enum MovementType {
  idle = 0,
  calibration = 1,
  walk = 2,
  run = 3,
  doubleLegSquat = 4,
  singleLegSquat = 5,
  other = 6,
}
